import React from "react"
import {BrowserRouter,Routes,Route,Navigate,useLocation} from "react-router-dom"
import "./App.css"

import Sidebar from "./components/Sidebar"
import AnalyticsTracker from "./components/AnalyticsTracker"

import LandingPage from "./pages/LandingPage"
import Installers from "./pages/Installers"
import UserGuide from "./pages/UserGuide"
import Terms from "./pages/Terms"
import PrivacyPolicy from "./pages/PrivacyPolicy"
import AnalyticsDashboard from "./pages/AnalyticsDashboard"

function AppLayout(){
const location = useLocation()
const isInstallerRoute = location.pathname === "/installers"
const isUserGuideRoute = location.pathname === "/user-guide"
const isLandingRoute = location.pathname === "/landing"
const isTermsRoute = location.pathname === "/terms"
const isPrivacyRoute = location.pathname === "/privacy"
const isAnalyticsRoute = location.pathname === "/admin/analytics"
const hideSidebar = isInstallerRoute || isUserGuideRoute || isLandingRoute || isTermsRoute || isPrivacyRoute || isAnalyticsRoute

return(
<div className="ac-app-shell">

<AnalyticsTracker/>
{!hideSidebar && <Sidebar/>}

<div className={hideSidebar ? "ac-app-main ac-app-main--login" : "ac-app-main"}>

<Routes>
<Route path="/" element={<Navigate to="/landing" replace />} />
<Route path="/login" element={<Navigate to="/landing" replace />} />
<Route path="/operator-login" element={<Navigate to="/landing" replace />} />
<Route path="/landing" element={<LandingPage/>}/>
<Route path="/installers" element={<Installers/>}/>
<Route path="/user-guide" element={<UserGuide/>}/>
<Route path="/terms" element={<Terms/>}/>
<Route path="/privacy" element={<PrivacyPolicy/>}/>
<Route path="/admin/analytics" element={<AnalyticsDashboard/>}/>

<Route path="*" element={<Navigate to="/landing" replace />} />

</Routes>

</div>

</div>
)
}

function App(){

return(

<BrowserRouter>
<AppLayout/>

</BrowserRouter>

)

}

export default App
